import template from './actionModal.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    visible: '<',
  },
};
